import IconComponent from "./Icon";
// import noCover from '../assets/images/no-cover.jpeg'

import { shelves } from "../assets/data/constants";

// icons
import {  FaArrowRight } from "react-icons/fa";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FaPencil } from "react-icons/fa6";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../api/apiClient";

const noCover = 'https://dryofg8nmyqjw.cloudfront.net/images/no-cover.png';

const CurrenlyReadingCard = ({ book, refreshLibrary }: { book: any, refreshLibrary: () => void }) => {
    const navigate = useNavigate();
    const [fastEdit, setFastEdit] = useState(false);
    const fastEditRef = useRef<any>(null);
    const [updatedPagesRead, setUpdatedPagesRead] = useState(book?.['Pages Read']);

    const updatePagesRead = async (pagesRead: number) => {
        const editedBook = {
            "my_rating": book['My Rating'],
            "number_of_pages": book['Number of Pages'],
            "pages_read": pagesRead,
            "date_read": book['Date Read'],
            "date_added": book['Date Added'],
            "exclusive_shelf": book['Exclusive Shelf'],
            "my_review": book['My Review'],
            "read_count":  book['Read Count'],
            "owned_copies": book['Owned Copies'],
            "cover_url": book['Cover URL'],
            "serie_id": book['Serie Id'],
            "serie_position": book['Serie Position'],
        }
        await axiosInstance.post(`/updateBook/${book['Book Id']}`, editedBook);
        refreshLibrary();
    }

    const finishBook = async () => {
        setFastEdit(!fastEdit);
        const editedBook = {
            "my_rating": book['My Rating'],
            "number_of_pages": book['Number of Pages'],
            "pages_read": book['Number of Pages'],
            "date_read": new Date(),
            "date_added": book['Date Added'],
            "exclusive_shelf": 'read',
            "my_review": book['My Review'],
            "read_count": parseInt(book['Read Count']) + 1,
            "owned_copies": book['Owned Copies'],
            "cover_url": book['Cover URL'],
            "serie_id": book['Serie Id'],
            "serie_position": book['Serie Position'],
        }
        try {
            await axiosInstance.post(`/updateBook/${book['Book Id']}`, editedBook);
            // refreshLibrary();
            navigate(`/book/${book['Book Id']}`);

        } catch (error) {
            console.error('Error fetching bestsellers:', error);
        }
    }

    useEffect(() => {
        setUpdatedPagesRead(book?.['Pages Read']);

        const handleClickOutside = (event: MouseEvent) => {
            if (fastEditRef.current && !fastEditRef.current.contains(event.target as Node)) {
                setFastEdit(false);
                setUpdatedPagesRead(book?.['Pages Read']);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [book]);

    useEffect(() => {
       console.log(updatedPagesRead, book?.['Pages Read']);
    }, [updatedPagesRead, book]);
   
    
    return (
        <div>
            <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full">
                <div className="flex gap-4 ">
                    <img className="object-cover rounded-xl w-32 h-48 cursor-pointer" onClick={() => navigate(`/book/${book?.['Book Id']}`)} alt="book cover" src={book?.['Cover URL'] || noCover} />
                    
                    <div className="flex flex-col items-start justify-between mt-2 w-full overflow-hidden">
                        <div>
                            <p className={`font-bold mb-0 text-[#60637A] ${ book&& ' hover:underline cursor-pointer '}`} onClick={() => book && navigate(`/book/${book?.['Book Id']}`)}>{book?.['Title'] || 'Not currently reading a book'}</p>
                            <p className="mb-0 text-[#60637A]">{book?.['Author'] || ''}</p>
                        </div>

                
                        {book ?
                        <>
                            <div className=" flex items-center gap-2 p-2 bg-[#60637A] rounded-xl mt-2 hover:cursor-pointer" onClick={() => setFastEdit(!fastEdit)}>
                                <h1 className="text-2xl font-bold text-white">{Math.round(book?.['Pages Read']/book['Number of Pages'] * 100)}%</h1>
                                <IconComponent icon={FaPencil} color="white" className="size-5 cursor-pointer"/>
                            </div>

                            {fastEdit &&
                            <div className="flex flex-col gap-2 p-2 border border-[#60637A] rounded-xl mt-2 w-full" ref={fastEditRef}>
                                
                                <form className="flex items-center" onSubmit={(e) => {e.preventDefault(); updatePagesRead(updatedPagesRead); setFastEdit(!fastEdit)}}>
                                    <div className="flex justify-center items-start gap-2 flex-col md:flex-col">
                                        <label className="text-sm font-bold text-[#60637A]" htmlFor="pages-read">On page:</label>
                                        <div className="flex gap-2 w-full justify-between ">
                                        <input id="pages-read" className="text-sm w-full border-b-2 border-gray-500" type="number" value={updatedPagesRead} onChange={(e) => {setUpdatedPagesRead(parseInt(e.target.value) || '')}} />
                                        <button type="submit">
                                            {book?.['Pages Read'] === updatedPagesRead ?
                                                <></>
                                                // <IconComponent icon={IoIosCloseCircleOutline} color="#60637A" className="size-5 cursor-pointer" />
                                                :
                                                <IconComponent icon={IoIosCheckmarkCircleOutline} color="#60637A" className="size-5 cursor-pointer" />
                                            }
                                        </button>
                                    </div>
                                    </div>
                                    
                                </form>
                                <button className="flex items-center justify-center gap-2 p-1 bg-[#8784D8] rounded-xl mt-2"  onClick={() => updatedPagesRead === book?.['Pages Read'] ? finishBook() : updatePagesRead(updatedPagesRead)}>
                                    <p className="text-xs font-bold text-white text-center">{updatedPagesRead === book?.['Pages Read'] ? 'Finish Book' : 'Update Book'}</p>
                                    <IconComponent icon={IoIosCheckmarkCircleOutline} color="white" className="size-5 cursor-pointer"/>
                                </button>
                            </div>
                            }

                            <span className="rounded-md shadow-sm">
                                <div className="inline-flex justify-between min-w-32 w-full px-4 py-1 mt-4 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md gap-2 items-center">
                                    <span className="text-xs">{shelves.find((s) => s.value === book['Exclusive Shelf'])?.name}</span>
                                </div>
                            </span>
                        </>
                        : 
                        <div className="bg-[#60637A] hover:bg-[#57676c] text-white font-bold py-2 px-4 rounded cursor-pointer flex gap-2 items-center" onClick={() => navigate('/library')}>
                            Go to Library
                            <IconComponent icon={FaArrowRight} color="white" className="size-5 cursor-pointer" />
                        </div>
                        }
                       
                    </div>
                </div>
            </div>
        </div>
    );
};export default CurrenlyReadingCard;